import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavItem, NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { shoppingListRouter } from './routing/shoppingListRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import ES_ES from './translations/es-ES.json'
import FR_FR from './translations/fr-FR.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { shoppingListAccessControl } from './access-control/shoppingListAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'shopping-list',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'shopping-list-dashboard-tool',
  },
  routes,
  translations: { EN_US, ES_ES, FR_FR },
  routers: {
    scoped: [shoppingListRouter],
  },
  navigationEntries: [
    {
      attachTo: NavItem.Shoppers, //old nav group -- delete this navItem when `dashboard_store_ops_nav` feature toggle is fully enabled
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View and manage shopping lists for store operations',
          labelId: 'shoppingListDomain.title',
          route: 'shopping-list-list',
          accessControl: shoppingListAccessControl,
        },
      ],
    },
    {
      attachTo: NavItem.StoreOperations,
      attachToV2: NavEntryPoint.OperationsLabor,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'View and manage shopping lists for store operations',
          labelId: 'shoppingListDomain.title',
          route: 'shopping-list-list',
          accessControl: shoppingListAccessControl,
          position: 7,
          positionNavV2: 4,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
